import casino from "./casino.json";
export default casino;
